module.exports = __webpack_public_path__ + "img/partsix_pic1.d2650248.png";